import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { filter, map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrentUserGQL, UserGQL, UserGql } from '@app/graphql/generated';

export interface CurrentUser extends UserGQL {
  isAdmin: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  _currentUser: any;
  constructor(private apollo: Apollo, private currentUserGQL: CurrentUserGQL) {}
  currentUserQueryRef: QueryRef<any>;

  currentUser(
    { includeUploads, pollInterval } = {
      includeUploads: false,
      pollInterval: 60 * 5 * 1000
    }
  ): Observable<CurrentUser | any> {
    this.currentUserQueryRef = this.currentUserGQL.watch(); // Poll every 5 minutes
    return this.currentUserQueryRef.valueChanges.pipe(
      filter(res => !res.loading),
      map(res => (res.data ? res.data.currentUser : { username: 'guest', permissions: [] })),
      map(user => {
        const isAdmin = user && user.role === 'admin';
        this._currentUser = user;
        return { ...user, isAdmin };
      }),
      shareReplay(1)
    );
  }

  refetchCurrentUser() {
    return this.currentUserQueryRef.refetch();
  }
}
